import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/login/two-factor-authentication/:uid",
    component: () => import("@/views/login/auth-two-factor"),
    hidden: true
  },
  {
    path: "/login/sms-authentication/:uid",
    component: () => import("@/views/login/auth-sms"),
    hidden: true
  },

  {
    path: "/403",
    component: () => import("@/views/error-page/403"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true
  },

  {
    path: "/lost-password",
    component: () => import("@/views/user/forgot-password"),
    hidden: true
  },

  {
    path: "/forgot/:token",
    component: () => import("@/views/user/new-password"),
    hidden: true
  },

  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: {
          title: "Dashboard",
          icon: "dashboard",
          noCache: true,
          roles: ["superadmin", "admin", "user"]
        }
      },
      {
        path: "info/:uid",
        name: "CompanyInfo",
        component: () => import("@/views/company/info"),
        meta: {
          title: "Company Info",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      },
      {
        path: "create/:vender_type",
        name: "CompanyCreate",
        component: () => import("@/views/company/create"),
        meta: {
          title: "Company Info",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      },
      {
        path: "edit/:uid",
        name: "CompanyEdit",
        component: () => import("@/views/company/edit"),
        meta: {
          title: "Company Info",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      }
    ]
  },
  {
    path: "/company",
    component: Layout,
    meta: {
      roles: ["superadmin"]
    },
    children: [
      {
        path: "",
        name: "Company",
        component: () => import("@/views/company/index"),
        meta: {
          title: "Company",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        }
      },
      {
        path: "info/:uid",
        name: "CompanyInfo",
        component: () => import("@/views/company/info"),
        meta: {
          title: "Company Info",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      },
      {
        path: "create/:vender_type",
        name: "CompanyCreate",
        component: () => import("@/views/company/create"),
        meta: {
          title: "Company Info",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      },
      {
        path: "edit/:uid",
        name: "CompanyEdit",
        component: () => import("@/views/company/edit"),
        meta: {
          title: "Company Info",
          icon: "company",
          noCache: true,
          activeMenu: "/company",
          roles: ["superadmin"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/project",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    children: [
      {
        path: "",
        name: "Project",
        component: () => import("@/views/project/index"),
        meta: {
          title: "Project",
          icon: "project",
          roles: ["superadmin", "admin", "user"]
        }
      },
      {
        path: ":project_uid",
        name: "ProjectCustomer",
        component: () => import("@/views/project/info"),
        meta: {
          title: "Project Info",
          icon: "project",
          activeMenu: "/project",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/bank-account",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin"]
    },
    children: [
      {
        path: "",
        name: "BankAccount",
        component: () => import("@/views/bank-account/index"),
        meta: {
          title: "Bank Account",
          icon: "bank-account",
          roles: ["superadmin", "admin"]
        }
      },
      {
        path: "view/:api_mode/:bankholder_id",
        name: "CustomerBankAccountDetail",
        component: () => import("@/views/bank-account/detail"),
        meta: {
          title: "Bank Account",
          icon: "bank-account",
          activeMenu: "/bank-account",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/customer",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    children: [
      {
        path: "",
        name: "Customer",
        component: () => import("@/views/customer/index"),
        meta: {
          title: "Customer",
          icon: "customer",
          roles: ["superadmin", "admin", "user"]
        }
      },
      {
        path: "view/:project_uid/:customer_uid",
        name: "CustomerBankAccount",
        component: () => import("@/views/customer/components/customer-info"),
        meta: {
          title: "Bank Account",
          icon: "bank-account",
          activeMenu: "/customer",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      },
      {
        path: "edit/:uid/:customer_type",
        name: "CustomerEdit",
        component: () => import("@/views/customer/edit"),
        meta: {
          title: "Customer Info",
          icon: "customer",
          noCache: true,
          activeMenu: "/customer",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      },
      {
        path: "v2/edit/:uid/:customer_type",
        name: "CustomerEdit",
        component: () => import("@/views/customer/v2/edit"),
        meta: {
          title: "Customer Info",
          icon: "customer",
          noCache: true,
          activeMenu: "/customer",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/introducer",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin"]
    },
    children: [
      {
        path: "",
        name: "Introducer",
        component: () => import("@/views/introducer/index"),
        meta: {
          title: "Introducer",
          icon: "introducer",
          roles: ["superadmin", "admin"]
        }
      }
    ]
  },

  {
    path: "/report",
    component: Layout,
    meta: {
      roles: ["superadmin"]
    },
    children: [
      {
        path: "",
        name: "Report",
        component: () => import("@/views/report/index"),
        meta: {
          title: "Report",
          icon: "report",
          roles: ["superadmin"]
        }
      }
    ]
  },

  {
    path: "/search",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    hidden: true,
    children: [
      {
        path: "",
        name: "Search",
        component: () => import("@/views/search/index"),
        meta: {
          title: "Report",
          icon: "report",
          roles: ["superadmin", "admin", "user"]
        }
      }
    ]
  },

  {
    path: "/pricing-template",
    component: Layout,
    meta: {
      roles: ["superadmin"]
    },
    children: [
      {
        path: "",
        name: "PricingTemplate",
        component: () => import("@/views/pricing/pricing-template"),
        meta: {
          title: "Pricing Template",
          icon: "template",
          roles: ["superadmin"]
        }
      }
    ]
  },

  {
    path: "/user",
    component: Layout,
    meta: {
      roles: ["superadmin", "admin"]
    },
    children: [
      {
        path: "",
        name: "User",
        component: () => import("@/views/user/index"),
        meta: {
          title: "User",
          icon: "user",
          roles: ["superadmin", "admin"]
        }
      }
    ]
  },

  {
    path: "/user-restrict",
    component: Layout,
    meta: {
      roles: ["superadmin"]
    },
    children: [
      {
        path: "",
        name: "Restrict",
        component: () => import("@/views/user/restrict"),
        meta: {
          title: "User restrict",
          icon: "restrict",
          roles: ["superadmin"]
        }
      }
    ]
  },

  {
    path: "/profile",
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    component: Layout,
    children: [
      {
        path: "",
        name: "Profile",
        component: () => import("@/views/profile/index"),
        meta: {
          title: "Profile",
          icon: "profile-setting",
          roles: ["superadmin", "admin", "user"]
        }
      }
    ]
  },
  {
    path: "/firewall",
    meta: {
      roles: ["superadmin", "admin", "user"],
      showBadge: true,
      badge: 0
    },
    hidden: true,
    component: Layout,
    children: [
      {
        path: "",
        name: "FirewallManage",
        component: () => import("@/views/firewall/index"),
        meta: {
          title: "Firewall",
          icon: "firewall",
          roles: ["superadmin", "admin", "user"]
        }
      },

      {
        path: "transaction/detail/:transactionid",
        name: "FirewallTransactionDetail",
        component: () => import("@/views/firewall/transaction/detail"),
        meta: {
          title: "Firewall",
          icon: "firewall",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      },

      {
        path: "beneficiary/detail/:membercode/:beneficiaryid",
        name: "FirewallBeneficiaryDetail",
        component: () => import("@/views/firewall/beneficiary/detail"),
        meta: {
          title: "Beneficiary",
          icon: "firewall",
          roles: ["superadmin", "admin", "user"]
        },
        hidden: true
      }
    ]
  },
  {
    path: "/rules",
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    component: Layout,
    hidden: true,
    children: [
      {
        path: "",
        name: "RulesManage",
        component: () => import("@/views/rules/index"),
        meta: {
          title: "Rules",
          icon: "rule",
          roles: ["superadmin", "admin"]
        },
        hidden: true
      }
    ]
  },
  {
    path: "/blacklist",
    meta: {
      roles: ["superadmin", "admin", "user"]
    },
    component: Layout,
    hidden: true,
    children: [
      {
        path: "",
        name: "BlacklistManage",
        component: () => import("@/views/blacklist/index"),
        meta: {
          title: "Blacklist",
          icon: "blacklist",
          roles: ["superadmin", "admin"]
        },
        hidden: true
      }
    ]
  },

  {
    path: "/webhooks",
    meta: {
      roles: ["superadmin", "admin"]
    },
    hidden: false,
    component: Layout,
    children: [
      {
        path: "",
        name: "WebhooksManage",
        component: () => import("@/views/webhook/index"),
        meta: {
          title: "Webhooks",
          icon: "webhooks",
          roles: ["superadmin", "admin"]
        }
      }
    ]
  },

  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  });

const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
